import React from 'react';
// common import
import Breadcrumbs from '../../../../common/components/Breadcrumbs/Breadcrumbs';
// data
import Data from '../../../../model/Data';
import AreaInterface from '../../../../model/Area';
import CityInterface from '../../../../model/City';
// styles
import './Header.css'

interface Props {
  className?: string;
  area: AreaInterface;
  city: CityInterface;
}

class Header extends React.Component<Props, {id: number}> {
  render(): JSX.Element {
    const { city, area } = this.props;
    const count = Data.Instance.vacancies({area: area.id, city: city.id}).length;
    const lastBreadcrumb = <>{ area.name } <span className="count">{count}</span></>
    const breadcrumbs = [
      {text: 'Все вакансии', link: `/${city.uri_alias}`},
      {text: lastBreadcrumb, link: `/${city.uri_alias}#${area.uri_alias}`},
    ];
    return (
      <div className="vacancy-detailed-header">
        <div className="container">
          <Breadcrumbs brand={Data.Instance.company} items={breadcrumbs} />
        </div>
      </div>
    );
  }
}

export default Header;
